var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 2V3.99967",
    stroke: "url(#paint0_linear_220_509)",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9971 2V3.99967",
    stroke: "url(#paint1_linear_220_509)",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9969 7.99805C16.2621 7.99805 16.5164 8.10339 16.7039 8.29089C16.8914 8.4784 16.9967 8.73271 16.9967 8.99788V16.9966C16.9967 18.0573 16.5754 19.0745 15.8254 19.8245C15.0753 20.5746 14.0581 20.9959 12.9974 20.9959H6.99837C5.93768 20.9959 4.92043 20.5746 4.17041 19.8245C3.42038 19.0745 2.99902 18.0573 2.99902 16.9966V8.99788C2.99902 8.73271 3.10436 8.4784 3.29187 8.29089C3.47937 8.10339 3.73369 7.99805 3.99886 7.99805H17.9966C19.0573 7.99805 20.0745 8.41941 20.8245 9.16943C21.5746 9.91945 21.9959 10.9367 21.9959 11.9974C21.9959 13.0581 21.5746 14.0753 20.8245 14.8254C20.0745 15.5754 19.0573 15.9967 17.9966 15.9967H16.9967",
    stroke: "url(#paint2_linear_220_509)",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 2V3.99967",
    stroke: "url(#paint3_linear_220_509)",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_509",
    x1: 9.99902,
    y1: 2.99984,
    x2: 10.999,
    y2: 2.99984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_220_509",
    x1: 13.9971,
    y1: 2.99984,
    x2: 14.9971,
    y2: 2.99984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_220_509",
    x1: 2.99902,
    y1: 14.497,
    x2: 21.9959,
    y2: 14.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_220_509",
    x1: 5.99902,
    y1: 2.99984,
    x2: 6.99902,
    y2: 2.99984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.5ea012abcdb42e6a0107521f11fad066.svg";
export { ForwardRef as ReactComponent };